export default __webpack_public_path__ + "static/luneta--prod-8e776140c3bd47945d4d0113b659526f.jpg";